import React, { Component, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('ErrorBoundary caught:', error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        backgroundColor: '#0d0d0d',
                        color: '#f1f5f9',
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: '2rem',
                    }}
                >
                    <h1 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '1rem' }}>
                        Something went wrong
                    </h1>
                    <p style={{ color: '#94a3b8', marginBottom: '2rem', maxWidth: '24rem' }}>
                        An unexpected error occurred. Reload the page to try again.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            backgroundColor: '#7c3aed',
                            color: '#fff',
                            border: 'none',
                            padding: '0.75rem 2rem',
                            borderRadius: '0.75rem',
                            fontWeight: 700,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            textTransform: 'uppercase',
                            letterSpacing: '0.1em',
                        }}
                    >
                        Reload
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
